export default {
    debug: false,

    configureWebpack: {
        devtool: 'source-map'
    }
}